var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("request", {
    attrs: {
      "download-document-by-attachment-id": _vm.downloadDocumentByAttachmentId,
      "get-compensatory-approvement-reasons":
        _vm.getCompensatoryApprovementReasons,
      "get-compensatory-reject-reasons":
        _vm.getCompensatoryRequestRejectReasons,
      "get-compensatory-request-student-service":
        _vm.getCompensatoryRequestStudentService,
      "get-compesatory-reposition-absence": _vm.getCompesatoryRepositionAbsence,
      "get-educational-compensatory-request":
        _vm.getEducationalCompensatoryRequest,
      "has-approvement-decline-panel-permissions":
        _vm.hasApprovementDeclinePanelPermissions,
      "has-permissions": _vm.hasPermissions,
      "has-update-due-interventions-permissions":
        _vm.hasUpdateDueInterventionsPermissions,
      "is-read-only": _vm.isReadOnly || _vm.isEducational,
      "reject-compensatory-request": _vm.rejectCompensatoryRequest,
      "request-service-data": _vm.serviceData,
      "save-compensatory-request": _vm.saveCompensatoryRequest,
      "submit-closing-analysis": _vm.submitClosingAnalysis,
      "update-compensatory-service-balance":
        _vm.updateCompensatoryServiceBalance,
      "update-due-interventions": _vm.updateDueInterventions
    },
    on: { "on-click-return": _vm.onReturnHandler }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }